/* eslint-disable prettier/prettier */
/* eslint-disable */

import React, { useContext, useMemo } from 'react';

import { ActivitySecondaryBlock } from '../basicBlocks';
import { IDictionaryItem } from '../../../../../api/types';
import { IEventData } from 'portfolio3/features/dataEntryForm';
import { AttachmentDocumentClass, DifferentValue } from '../../../../../const';

import { LocalDataEntryFormContext } from '../../context/localDataEntryFormContext';
import { BaseInputLabel, FormControl, Input } from 'portfolio3/ui-kit';
import { FormHelperText } from '@mui/material';
import { Select } from 'portfolio3/ui-kit/selects';
import { IController, TokenFieldController } from 'portfolio3/ui-kit/types';
import { StretchyTokenField } from 'portfolio3/ui-kit/autocomplete';

interface IOlympiadSecondaryBlockProps {
  subjectOptions: IDictionaryItem[];
  eventLevelOptions: IDictionaryItem[];
  olympiadLevelOptions: IDictionaryItem[];
  eventData?: IEventData;
}

const OlympiadSecondaryBlock: React.FC<IOlympiadSecondaryBlockProps> = ({
  subjectOptions,
  eventLevelOptions,
  olympiadLevelOptions,
  eventData,
}) => {
  const { isMobile, inputRenderMode, inputSize, formData, formErrors, onChangeFormData, onChangeFormErrors } =
    useContext(LocalDataEntryFormContext);

  const secondNameController = useMemo(
    () => ({
      handleChange: (secondName: string) => {
        onChangeFormData((prevstate) => ({
          ...prevstate,
          secondName,
        }));
        onChangeFormErrors((prevstate) => ({
          ...prevstate,
          secondNameError: false,
        }));
      },
      handleBlur: (secondName: any) => {
        if (!secondName) {
          onChangeFormErrors((prevstate) => ({
            ...prevstate,
            secondNameError: true,
          }));
        }
      },
    }),
    [formData.id],
  );

  const subjectController: TokenFieldController = useMemo(
    () => ({
      handleChange: (subjects) => {
        onChangeFormData((prevState) => ({
          ...prevState,
          subjectId: subjects.map((subject) => subject.code),
        }));
        onChangeFormErrors((prevState) => ({
          ...prevState,
          subjectError: subjects.length === 0,
        }));
      },
      handleBlur: (subjects) => {
        onChangeFormErrors((prevState) => ({
          ...prevState,
          subjectError: subjects.length === 0,
        }));
      },
    }),
    [formData.id],
  );

  const profileController = useMemo(
    () => ({
      handleChange: (profile: string) => {
        onChangeFormData((prevstate) => ({
          ...prevstate,
          profile,
        }));
      },
    }),
    [formData.id],
  );

  const olympiadLevelController: IController<string | undefined> = useMemo(
    () => ({
      handleChange: (olympiadLevel) => {
        onChangeFormData((prevstate) => ({
          ...prevstate,
          olympiadLevel: Number(olympiadLevel),
        }));
      },
    }),
    [formData.id],
  );
  const showSecondName = eventData?.name === DifferentValue || formData.secondName;
  const additionalTopControllers = (
    <>
      {showSecondName && (
        <FormControl
          sx={{ width: '100%' }}
          required
          error={formErrors.secondNameError}
          renderMode={inputRenderMode}
          inputSize={inputSize}
          label={<BaseInputLabel>Название олимпиады</BaseInputLabel>}
          helper={formErrors.secondNameError && <FormHelperText>Выберите название олимпиады</FormHelperText>}
          control={
            <Input
              renderMode={inputRenderMode}
              size={inputSize}
              placeholder="Введите название олимпиады..."
              value={formData.secondName}
              controller={secondNameController}
            />
          }
        />
      )}
      <FormControl
        required
        error={formErrors.subjectError}
        renderMode={inputRenderMode}
        inputSize={inputSize}
        label={
          <BaseInputLabel>
            {isMobile ? 'Предмет / дисциплина' : 'Предмет / дисциплина (один или несколько)'}
          </BaseInputLabel>
        }
        helper={formErrors.subjectError && <FormHelperText>Выберите хотя бы один предмет</FormHelperText>}
        control={
          <StretchyTokenField
            size={inputSize}
            inputRenderMode={inputRenderMode}
            options={subjectOptions || []}
            controller={subjectController}
            value={formData.subjectId}
            placeholder="Начните вводить название предмета..."
          />
        }
      />
    </>
  );

  const additionalMiddleControllers = (
    <>
      <FormControl
        sx={{ width: '100%' }}
        renderMode={inputRenderMode}
        inputSize={inputSize}
        label={<BaseInputLabel>Уровень олимпиады</BaseInputLabel>}
        control={
          <Select
            inputRenderMode={inputRenderMode}
            inputSize={inputSize}
            placeholder="Выберите уровень олимпиады..."
            value={formData.olympiadLevel}
            options={olympiadLevelOptions}
            controller={olympiadLevelController}
            strictMaxWidth
          />
        }
      />
      <FormControl
        sx={{ width: '100%' }}
        renderMode={inputRenderMode}
        inputSize={inputSize}
        label={<BaseInputLabel>Профиль олимпиады</BaseInputLabel>}
        control={
          <Input
            renderMode={inputRenderMode}
            size={inputSize}
            placeholder="Введите профиль олимпиады..."
            value={formData.profile}
            controller={profileController}
          />
        }
      />
    </>
  );

  const organizatorLabel = 'Организатор олимпиады';
  const organizatorPlaceholder = 'Введите название организатора олимпиады...';
  return (
    <ActivitySecondaryBlock
      eventLevelOptions={eventLevelOptions}
      additionalTopControllers={additionalTopControllers}
      additionalMiddleControllers={additionalMiddleControllers}
      eventData={eventData}
      organizatorLabel={organizatorLabel}
      organizatorPlaceholder={organizatorPlaceholder}
      attachmentDocumentClass={AttachmentDocumentClass.OLYMPIAD}
    />
  );
};

export default OlympiadSecondaryBlock;
